import React, { useEffect, useState } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from '../components/Navbar';
import { DASHBOARD_STATUS_ENDPOINT } from '../utils/api';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

function LoginDashboard() {
  const [user, setUser] = useState(null);
  const [stats, setStats] = useState({
    total: 0,
    approved: 0,
    pending: 0,
    rejected: 0,
    monthlyCounts: [],
    departmentCounts: [],
    userCounts: [],
  });

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      alert('Unauthorized! Please log in.');
      window.location.href = '/';
      return;
    }

    try {
      const decoded = JSON.parse(atob(token));
      setUser(decoded);
      fetchDashboardStats(decoded.customer_id, token);
    } catch (error) {
      console.error('Invalid token:', error);
      alert('Invalid session. Please login again.');
      localStorage.removeItem('token');
      window.location.href = '/';
    }
  }, []);

  const fetchDashboardStats = async (customer_id, token) => {
    try {
      const res = await axios.post(DASHBOARD_STATUS_ENDPOINT, {
        customer_id,
        token,
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (res.data.success) {
        setStats({
          total: res.data.stats.total || 0,
          approved: res.data.stats.approved || 0,
          pending: res.data.stats.pending || 0,
          rejected: res.data.stats.rejected || 0,
          monthlyCounts: res.data.stats.monthlyCounts || [],
          departmentCounts: res.data.stats.departmentCounts || [],
          userCounts: res.data.stats.userCounts || [],
        });
      }
    } catch (err) {
      console.error('Error fetching dashboard stats:', err);
    }
  };

  const barOptions = (title) => ({
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      title: {
        display: true,
        text: title,
        font: { size: 14 }
      }
    },
    scales: {
      x: { grid: { display: false } },
      y: { beginAtZero: true }
    }
  });

  const monthlyBarData = {
    labels: stats.monthlyCounts.map((m) => m.month),
    datasets: [{ label: 'Visitors', data: stats.monthlyCounts.map((m) => m.count), backgroundColor: '#0d6efd' }]
  };

  const departmentBarData = {
    labels: stats.departmentCounts.map((d) => d.department),
    datasets: [{ label: 'Visitors', data: stats.departmentCounts.map((d) => d.count), backgroundColor: '#198754' }]
  };

  const userBarData = {
    labels: stats.userCounts.map((u) => u.user_name),
    datasets: [{ label: 'Visitors', data: stats.userCounts.map((u) => u.count), backgroundColor: '#6610f2' }]
  };

  if (!user) return null;

  return (
    <>
      <Navbar />
      <div className="container mt-3">
        <h4 className="mb-3">Visitor Dashboard</h4>

        {/* Summary Cards */}
        <div className="row g-3 mb-3">
          {[
            { label: 'Total', value: stats.total, color: 'primary' },
            { label: 'Approved', value: stats.approved, color: 'success' },
            { label: 'Pending', value: stats.pending, color: 'warning', text: 'dark' },
            { label: 'Rejected', value: stats.rejected, color: 'danger' }
          ].map((card, idx) => (
            <div key={idx} className="col-6 col-md-3">
              <div className={`card text-${card.text || 'white'} bg-${card.color} shadow-sm text-center p-2`}>
                <small>{card.label}</small>
                <h5 className="fw-bold">{card.value}</h5>
              </div>
            </div>
          ))}
        </div>

        {/* Charts in 2 columns */}
        <div className="row g-3">
          <div className="col-lg-6 col-md-12">
            <div className="card shadow-sm p-2" style={{ height: '250px' }}>
              <Bar data={monthlyBarData} options={barOptions('Monthly Visitors')} />
            </div>
          </div>
          <div className="col-lg-6 col-md-12">
            <div className="card shadow-sm p-2" style={{ height: '250px' }}>
              <Bar data={departmentBarData} options={barOptions('Department-wise Visitors')} />
            </div>
          </div>
        </div>

        <div className="row g-3 mt-1">
          <div className="col-lg-6 col-md-12">
            <div className="card shadow-sm p-2" style={{ height: '250px' }}>
              <Bar data={userBarData} options={barOptions('User-wise Visitors')} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LoginDashboard;
